import { PermissionInvite } from "../../../model/permissions/PermisisonInvite";
import { Permission } from "../../../model/permissions/Permission";
import { TEAM_ROLES } from "../../../model/permissions/team-role.config";
import { PermissionAction } from "../../../model/permissions/types/PermissionAction";
import { TeamRole } from "../../../model/permissions/types/TeamRole.enum";
import { User } from "../../../model/user/User";
import { UserRoles } from "../../../model/user/types/UserRoles";

export const sortPermissions = (
  permissions: Partial<Record<PermissionAction, boolean>>,
): Partial<Record<PermissionAction, boolean>> => {
  const ordered: Partial<Record<PermissionAction, boolean>> = {};
  const keys: PermissionAction[] = [
    PermissionAction.READ,
    PermissionAction.CREATE,
    PermissionAction.UPDATE,
    PermissionAction.DELETE,
  ];

  keys.forEach((key) => {
    if (key in permissions) {
      ordered[key] = permissions[key];
    }
  });

  return ordered;
};

export const getInviteLink = (invite: PermissionInvite) => {
  return `${process.env.REACT_APP_APP_URL}/permissions/invite?inviteMode=true&inviteCode=${invite.inviteCode}&inviteEmail=${invite.inviteeEmail}`;
};

/**
 * A role only means something inside a team. A stored `orgRole` on someone
 * with no team is stale, and a member from before roles existed has none.
 */
export const getTeamRole = (user?: User | null): TeamRole | undefined => {
  if (user?.organizationId) {
    return user.orgRole ?? TeamRole.STAFF;
  }

  if (user?.roles?.includes(UserRoles.ORGANIZATION)) {
    return TeamRole.OWNER;
  }

  return undefined;
};

export const isCustomizedFromRole = (
  role: TeamRole,
  permissions?: Permission["permissions"],
) => {
  const defaults = TEAM_ROLES.find(({ id }) => id === role)?.defaultActions;

  if (!defaults || !permissions) {
    return false;
  }

  return Object.values(permissions).some((actions) =>
    Object.values(PermissionAction).some(
      (action) => Boolean(actions?.[action]) !== defaults.includes(action),
    ),
  );
};
